interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter((item) => {
    if (totalPages <= 7) return true;
    return item === 1 || item === totalPages || Math.abs(item - page) <= 1;
  });

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true" />
        上一页
      </button>

      {pages.map((item, index) => {
        const prev = pages[index - 1];
        const showGap = prev !== undefined && item - prev > 1;
        return (
          <span key={item} className="flex items-center gap-1.5">
            {showGap && <span className="px-1 text-xs text-foreground-400">...</span>}
            <button
              type="button"
              onClick={() => onChange(item)}
              aria-current={item === page ? "page" : undefined}
              aria-label={`第 ${item} 页`}
              className={`h-9 w-9 cursor-pointer rounded-md text-xs transition-colors ${
                item === page
                  ? "bg-primary-500 font-semibold text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
      </button>
    </nav>
  );
}